async function requestJson(path, options = {}) {
  const response = await fetch(path, {
    credentials: "include",
    headers: {
      Accept: "application/json",
      ...(options.body ? { "Content-Type": "application/json" } : {}),
    },
    ...options,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const err = new Error(data.message || `Request failed (${response.status})`);
    throw err;
  }
  return data;
}

function buildQuery(params = {}) {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value != null && value !== "") search.set(key, String(value));
  }
  const q = search.toString();
  return q ? `?${q}` : "";
}

export async function fetchCanonicalVehicles(params = {}) {
  return requestJson(`/api/admin/mobility/canonical-vehicles${buildQuery(params)}`);
}

export async function fetchCanonicalVehicle(id) {
  return requestJson(`/api/admin/mobility/canonical-vehicles/${encodeURIComponent(id)}`);
}

export async function fetchVehicleDuplicateCandidates(params = {}) {
  return requestJson(
    `/api/admin/mobility/vehicle-duplicate-candidates${buildQuery(params)}`
  );
}

export async function confirmIdentityMatch(id, body = {}) {
  return requestJson(
    `/api/admin/mobility/vehicle-identity-matches/${encodeURIComponent(id)}/confirm`,
    { method: "POST", body: JSON.stringify(body) }
  );
}

export async function rejectIdentityMatch(id, body = {}) {
  return requestJson(
    `/api/admin/mobility/vehicle-identity-matches/${encodeURIComponent(id)}/reject`,
    { method: "POST", body: JSON.stringify(body) }
  );
}

export async function runListingDuplicateDetection(listingId) {
  return requestJson(
    `/api/admin/mobility/vehicle-listings/${encodeURIComponent(listingId)}/run-duplicate-detection`,
    { method: "POST" }
  );
}

export async function runSourceDuplicateDetection(sourceId, params = {}) {
  return requestJson(
    `/api/admin/mobility/vehicle-sources/${encodeURIComponent(sourceId)}/run-duplicate-detection${buildQuery(params)}`,
    { method: "POST" }
  );
}

export async function detachListingCanonical(listingId, body = {}) {
  return requestJson(
    `/api/admin/mobility/vehicle-listings/${encodeURIComponent(listingId)}/detach-canonical`,
    { method: "POST", body: JSON.stringify(body) }
  );
}

export async function recalculateCanonicalVehicle(id) {
  return requestJson(
    `/api/admin/mobility/canonical-vehicles/${encodeURIComponent(id)}/recalculate`,
    { method: "POST" }
  );
}
